export const CHANGE_FIND_STRING = '[GLOBAL SEARCH] CHANGE_FIND_STRING';
export const FIND_BY_ID = '[GLOBAL SEARCH] FIND BY ID';
export const INITIATE = '[GLOBAL SEARCH] INITIATE';
